import { render, staticRenderFns } from "./FinancialRisk.vue?vue&type=template&id=56135c18&scoped=true&"
import script from "./FinancialRisk.vue?vue&type=script&lang=js&"
export * from "./FinancialRisk.vue?vue&type=script&lang=js&"
import style0 from "./FinancialRisk.vue?vue&type=style&index=0&id=56135c18&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56135c18",
  null
  
)

export default component.exports